import type { Slug } from 'sanity';

export function slugToPath(slugs: Slug[]) {
  return `/${slugs.map((slug) => slug?.current).join('/')}`;
}
